import * as React from 'react'
import type {SVGProps} from 'react'
const SvgSignOut = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={21} viewBox="0 0 16 21" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.73 0a2.98 2.98 0 0 1 2.976 2.977.75.75 0 0 1-1.5 0c0-.815-.662-1.477-1.477-1.477H2.977c-.815 0-1.477.662-1.477 1.477v14.101c0 .814.662 1.477 1.477 1.477h6.752c.815 0 1.477-.663 1.477-1.477a.75.75 0 0 1 1.5 0 2.98 2.98 0 0 1-2.977 2.977H2.977A2.98 2.98 0 0 1 0 17.078v-14.1A2.98 2.98 0 0 1 2.977 0zm1.378 6.419a.8.8 0 0 1 1.131-.002l3.04 3.04a.803.803 0 0 1 0 1.132l-3.04 3.038a.8.8 0 0 1-.565.235.8.8 0 0 1-.566-1.365l2.474-2.474-2.474-2.474a.8.8 0 0 1 0-1.13m.099 2.735a.8.8 0 1 1 0 1.6H5.35a.8.8 0 1 1 0-1.6z"
        />
    </svg>
)
export default SvgSignOut
